
const rrfConfig = {
    userProfile: "users",
    useFirestoreForProfile: true
}

export default rrfConfig;